import { Error } from "./styles";

const Component = ({ children, ...rest }) => {
  return <Error {...rest}>{children}</Error>;
};
export default Component;
